import { dayjs } from "@outschool/time";
import { useSession } from "@outschool/ui-auth";
import React from "react";

import { RenderableTopicCard } from "../../../../shared/parentDashboard/cardTypes/Topic";
import {
  TopicTitleType,
  useCardTitleTranslation
} from "../../../../shared/parentDashboard/cardTypes/useCardTitleTranslation";
import HeroCard from "../cards/HeroCard";
import SearchListingsCard from "../cards/SearchListingsCard";
import BasicList from "../lists/BasicList";

export { type } from "../../../../shared/parentDashboard/cardTypes/Topic";

export function Component({
  card,
  trackingProperties,
  loadAfterDelay,
  isCategory = false
}: {
  card: RenderableTopicCard;
  trackingProperties: Record<string, string | number>;
  loadAfterDelay: number;
  isCategory?: boolean;
}) {
  const { userTimeZone } = useSession();
  const title = useCardTitleTranslation(
    card.title as TopicTitleType,
    isCategory
  );

  if (card.criteria?.dates?.to) {
    if (
      dayjs
        // @ts-ignore TS(2769): No overload matches this call.
        .tz(card.criteria?.dates?.to, userTimeZone)
        .endOf("day")
        .isBefore(dayjs())
    ) {
      return null;
    }
  }
  if (card.display === "list") {
    return (
      <SearchListingsCard
        id={card.id}
        title={title}
        subtitle={card.subtitle}
        url={card.url}
        searchFilters={card.searchFilters}
        trackingProperties={trackingProperties}
        loadAfterDelay={loadAfterDelay}
      />
    );
  }
  return (
    <HeroCard
      id={card.id}
      title={title}
      imageUrl={card.imageUrl}
      url={card.url}
      showImageOnTop={false}
      trackingProperties={trackingProperties}
    />
  );
}

export function ListComponent({ card }: { card: RenderableTopicCard }) {
  return <BasicList card={card} />;
}
